var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-page',{attrs:{"permanent":true,"override-message":"Sign-in in Progress"}})}
var staticRenderFns = []

export { render, staticRenderFns }